// Remembers where a visitor came from, so each quote request can say "Came from: ...".
// Saved in this browser only (never sent anywhere until they submit the form) for 30 days.
// A new outside source replaces the old one; coming back by typing the address keeps it.

const KEY = 'hr_lead_source';
const KEEP_DAYS = 30;

// Names for ?utm_source= values used in links we hand out (Google listings, sponsors).
const NAMED_SOURCES = {
  'gbp-niles': 'Google Business Profile (Niles)',
  'gbp-gaylord': 'Google Business Profile (Gaylord)',
  laughlounge: 'Laugh Lounge',
  facebook: 'Facebook',
  'facebook-niles': 'Facebook (Niles page)',
  'facebook-northern-mi': 'Facebook (Northern MI page)',
  qr: 'QR code'
};

const REFERRERS = [
  [/^gemini\.google\.com$/, 'Gemini'],
  [/(^|\.)google\./, 'Google search'],
  [/(^|\.)bing\.com$/, 'Bing search'],
  [/(^|\.)yahoo\./, 'Yahoo search'],
  [/(^|\.)duckduckgo\.com$/, 'DuckDuckGo search'],
  [/(^|\.)(facebook\.com|fb\.com|fb\.me)$/, 'Facebook'],
  [/(^|\.)instagram\.com$/, 'Instagram'],
  [/(^|\.)(chatgpt\.com|openai\.com)$/, 'ChatGPT'],
  [/(^|\.)perplexity\.ai$/, 'Perplexity'],
  [/(^|\.)claude\.ai$/, 'Claude'],
  [/(^|\.)nextdoor\.com$/, 'Nextdoor'],
  [/(^|\.)bbb\.org$/, 'BBB'],
  [/(^|\.)yelp\.com$/, 'Yelp'],
  [/(^|\.)undergroundlaughlounge\.com$/, 'Laugh Lounge']
];

function read() {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (saved && saved.at > Date.now() - KEEP_DAYS * 86400000) return saved;
  } catch (e) { /* storage blocked: fall through */ }
  return null;
}

function describe(url, referrer) {
  const params = url.searchParams;
  const utm = (params.get('utm_source') || '').trim().toLowerCase();
  if (utm) {
    const medium = (params.get('utm_medium') || '').trim();
    return NAMED_SOURCES[utm] || utm + (medium ? ' (' + medium + ')' : '');
  }
  if (params.has('gclid') || params.has('gbraid') || params.has('wbraid')) return 'Google Ads';
  if (params.has('fbclid')) return 'Facebook';
  if (!referrer) return '';
  let host;
  try {
    host = new URL(referrer).hostname.replace(/^www\./, '');
  } catch (e) {
    return '';
  }
  if (host === url.hostname.replace(/^www\./, '')) return '';
  const known = REFERRERS.find(([pattern]) => pattern.test(host));
  return known ? known[1] : host;
}

let current = null;

export function captureLeadSource() {
  const url = new URL(window.location.href);
  const source = describe(url, document.referrer);
  const saved = read();
  if (source) {
    current = { source, landing: url.pathname, at: Date.now() };
    try { localStorage.setItem(KEY, JSON.stringify(current)); } catch (e) { /* not saved */ }
  } else {
    current = saved || { source: 'Typed in the address or a bookmark', landing: url.pathname, at: Date.now() };
  }
}

export function getLeadSource() {
  return current || read() || { source: 'Unknown', landing: '' };
}
